<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="save()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">Upload Images</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
      [disabled]="loading"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Select Images</label>
      <input
        type="file"
        class="form-control"
        accept="image/*"
        formControlName="file"
        (change)="onFileChange($event)"
        multiple
      />
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-default mr-1"
      type="button"
      [disabled]="loading"
      (click)="activeModal.dismiss('')"
      >Cancel</button
    >
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="noFileSelectedOrIsLoading"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      >Upload</button
    >
  </div>
</form>
